import { useAuth0 } from "@auth0/auth0-react";
import Dialog from "@material-ui/core/Dialog";
import CircularProgress from "@mui/material/CircularProgress";
import CommunicationService from "Lib/API/Communication/index";
import {
  default as FinanceSetting,
  default as FinancialSetting,
} from "Lib/API/FinanceSetting/FinanceSetting";
import ChevronIcon from "assets/icons/chevron-left.svg";
import closeIcon from "assets/icons/close.svg";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { CheckBox } from "components/CheckBox/CheckBox";
import Editor from "components/Editor/Editor";
import InfoTooltip from "components/InfoTooltip";
import { InputField as InputFieldPrimary } from "components/InputField";
import { InputField } from "components/InputField/InputField";
import { LabelField } from "components/LabelField";
import EmailsList from "components/ShareDocuments/Emails/EmailsList";
import { getRandColor } from "components/ShareDocuments/Emails/emailRandomColor";
import Button from "components/button/Button";
import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import { setOpenTemplateCreationDialog } from "services/api/communication";
import { emailRegex } from "utils/validation";
import ConfirmSaveTemplateModal from "../ConfirmSaveTemplateModal/ConfirmSaveTemplateModal";
import CreateLetterEditor from "./CreateLetterEditor";
import "./createLetter.scss";
import { fontConfig } from "theme/fontConfig";

const selectControlStyles = {
  backgroundColor: "transparent",
  borderColor: "#E1E1E7",
  color: "#b5b5c3",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
  width: "250px",
  marginLeft: "20px",
};
const selectStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "200px",
  }),
};

const EmailEditor = ({
  closeModal,
  createNewTemplate,
  type,
  dropDownTypes,
  previewTemplete,
  setHtmlContentEdit,
  setJsonContentEdit,
  jsonContentEdit,
  enableEdit,
  tokenListEdit,
  templateDetails,
  setEnableEdit,
  htmlContentEdit,
  setRefresh,
  withoutHeader,
  buttonClassName,
  setCampaignModal,
  prevouis,
  prevouisOnClick,
  onNext,
  setTemplate,
  withSubject,
  isDuplicateEdit,
  onDuplicateEditSave,
}) => {
  const dispatch = useDispatch()
  const { getAccessTokenSilently } = useAuth0();
  const [jsonContent, setJsonContent] = useState({});
  const [htmlContent, setHtmlContent] = useState("");
  const [openConfirmSaveTemplateModal, setOpenConfirmSaveTemplateModal] =
    useState(false);
  const [saveTemplateLoading, setSaveTemplateLoading] = useState(false);
  const [tokenList, setTokenList] = useState([]);
  const [dropDownType, setDropDownType] = useState({ label: "Communications", value: "communication" });
  const emailEditorRef = useRef({ projectId: 195575 });
  const [updateTemplateLoading, setUpdateTemplateLoading] = useState(false);
  const [templateContent, setTemplateContent] = useState("");
  const accountEmail = JSON.parse(localStorage.getItem("email_address"));
  const [savedEmails, setSavedEmails] = useState([
    {
      email: accountEmail,
      image: accountEmail.charAt(0).toUpperCase(),
      color: getRandColor(),
    },
  ]);
  const [testEmailloading, setTestEmailloading] = useState(false);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      education: {
        registrationEmail: orgData?.communication?.education?.registrationEmail,
        approvalEmail: orgData?.communication?.education?.approvalEmail,
        rejectEmail: orgData?.communication?.education?.rejectEmail,
      },
      email: {
        replyTo: enableEdit ? orgData?.communication?.email?.replyTo : "",
      },
      replyTo: (enableEdit || isDuplicateEdit)
        ? (templateDetails?.replyTo === null || templateDetails?.replyTo === undefined)
          ? ""
          : templateDetails?.replyTo
        : "",
      templateName: "",
      useDefault: isDuplicateEdit
        ? (templateDetails?.useDefault !== undefined ? templateDetails?.useDefault : true)
        : true,
      addLogo: templateDetails?.addLogo,
      subject: templateDetails?.subject,
    },
    validationSchema: "",
  });

  const buttons = [
    {
      id: "cancel",
      label: "Cancel",
      action: closeModal || setCampaignModal,
      className: "create-letter__actions-btn cancel",
      variant: "primary-outline",
    },
    {
      id: "save",
      label: "Save",
      variant: "primary",
      action: () => {
        setOpenConfirmSaveTemplateModal(true);
      },
      className: "create-letter__actions-btn submit",
      disabled:
        enableEdit || previewTemplete
          ? false
          : (!formik?.values?.useDefault && !formik?.values?.replyTo) || (withSubject && !formik?.values?.subject) ||
          formik?.values?.error,
    },
  ];
  let orgData = JSON.parse(
    localStorage.getItem("organization") !== "undefined"
      ? localStorage.getItem("organization")
      : "{}"
  );

  const addEmailsHandler = ({ type, email }) => {
    if (savedEmails?.some((savedEmail) => savedEmail.email === email)) return;
    setSavedEmails((prev) => [
      ...prev,
      {
        type,
        email,
        image: email.charAt(0).toUpperCase(),
        color: getRandColor(),
      },
    ]);
  };
  const removeEmailHandler = (email) => {
    setSavedEmails((prev) => prev.filter((item) => item.email !== email));
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };

  const handleOnChange = (value) => {
    formik.setFieldValue("replyTo", value);
    if (!value) {
      formik.setFieldValue("error", false);
    } else {
      !emailRegex.test(value)
        ? formik.setFieldValue("error", true)
        : formik.setFieldValue("error", false);
    }
  };

  const toggleEditorPreview = (type) => {
    const unlayer = emailEditorRef.current?.editor;
    if (type === "show") {
      unlayer.showPreview();
    } else if (type === "hide") {
      unlayer.hidePreview();
    }
  };
  const createTemplateHandler = async () => {
    const template = {
      jsonContent,
      htmlContent,
      newTemplate: true,
      replyTo: formik.values?.replyTo,
      useDefault: formik.values?.useDefault,
      ...(withSubject ? { subject: formik.values?.subject } : {}),
    };
    createNewTemplate({ template, newTemplate: true });
    setOpenConfirmSaveTemplateModal(false);
  };

  const saveTemplateHandler = async () => {
    setSaveTemplateLoading(true);
    const token = await getAccessTokenSilently();
    const data = {
      type: type || dropDownType?.value,
      addLogo: false,
      title: formik.values?.templateName,
      replyTo: formik.values?.replyTo,
      content: formik.values?.htmlContent,
      useDefault: formik.values?.useDefault,
      jsonContent,
      htmlContent,
      ...(withSubject ? { subject: formik.values?.subject } : {}),

    };

    try {
      const response = await FinancialSetting.createTemplate(token, data);
      createNewTemplate && createNewTemplate(response?.result, false);
      setSaveTemplateLoading(false);
      setRefresh && setRefresh(true);
      toastr.success("Success", "saved successfully");
      onNext && onNext();
      setTemplate && setTemplate(response?.result)
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Somthing Went Wrong");
      setSaveTemplateLoading(false);
    }
  };

  const getTemplateTokens = async () => {
    const fileType = type || dropDownType?.value;
    const token = await getAccessTokenSilently();
    try {
      const response = await FinanceSetting.getTemplateTokens(token, fileType);
      const tokens = response?.result;
      setTokenList(tokens);
    } catch (error) {
      toastr.error("Error", error?.data?.message);
    }
  };
  const updateTemplate = async () => {
    setUpdateTemplateLoading(true);

    const data = {
      htmlContent: htmlContentEdit,
      jsonContent: jsonContentEdit,
      replyTo: formik.values?.replyTo || null,
      useDefault: formik.values?.useDefault,
      ...(withSubject ? { subject: formik.values?.subject } : {}),
    };

    if (isDuplicateEdit && onDuplicateEditSave) {
      onDuplicateEditSave(data);
      setUpdateTemplateLoading(false);
      setOpenConfirmSaveTemplateModal(false);
      dispatch(setOpenTemplateCreationDialog(false));
      setEnableEdit && setEnableEdit(false);
      return;
    }

    const token = await getAccessTokenSilently();
    try {
      const response = await FinanceSetting.updateTemplateById(
        token,
        templateDetails?._id,
        data
      );
      setTemplateContent(response?.result?.content?.replace(/&lt;/g, "<"));
      toastr.success("Success", "updated successfully");
      setUpdateTemplateLoading(false);
      toggleEditorPreview && toggleEditorPreview("show");
      setOpenConfirmSaveTemplateModal(false);
      dispatch(setOpenTemplateCreationDialog(false));
      setEnableEdit && setEnableEdit(false);
      setRefresh && setRefresh(true);
    } catch (error) {
      toastr.error("Error", error?.data?.message);
      setUpdateTemplateLoading(false);
    }
  };
  const sendTestEmail = async () => {
    setTestEmailloading(true);
    const token = await getAccessTokenSilently();
    const data = {
      templateId: templateDetails?._id,
      toEmails: savedEmails,
    };
    try {
      const response = await CommunicationService.sendTemplateTestEmail(
        token,
        data
      );
      toastr.success("Success", "Email sent successfully");
    } catch (error) {
      toastr.error("Error", error?.data?.message);
    } finally {
      setTestEmailloading(false);
    }
  };
  useEffect(() => {
    if(previewTemplete) return
    getTemplateTokens();
  }, [dropDownType]);

  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="create-letter">
      {!withoutHeader && (
        <>
          <div className="create-letter__header">
            <div className="create-letter__header-close" onClick={closeModal}>
              <img src={ChevronIcon} alt="" />
            </div>
            <div className="create-letter__header-close" onClick={closeModal}>
              <img src={closeIcon} alt="" />
            </div>
          </div>
          <hr />
        </>
      )}

      <div className="create-letter__container">
        <div className="email-section-wrapper">
            {(!previewTemplete || isDuplicateEdit) && dropDownTypes && !isDuplicateEdit && (
              <div className="select-type">
                <LabelField
                  title={"Module"}
                  style={{
                    color: "black",
                    fontWeight: 400,
                    fontSize: "12px",
                    paddingTop: "5px",
                  }}
                />
                <Select
                  menuPosition={"fixed"}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  placeholder="Select a Module"
                  options={[
                    { label: "Education", value: "education" },
                    { label: "Events", value: "event" },
                    { label: "Forms", value: "form" },
                    { label: "Communications", value: "communication" },
                  ]}
                  styles={selectStyles}
                  onChange={(value) => {
                    setDropDownType(value);
                  }}
                  value={dropDownType}
                  components={{ DropdownIndicator }}
                />
                <InfoTooltip text="Determines which app area (Events, Forms, Communications, etc.) this template becomes available in." style={{ marginLeft: '6px', marginBottom: '8px' }} />
              </div>
            )}
            <div style={{ display: "flex", alignItems: "center" }}>
              <InputField
                label="Reply to email"
                type="text"
                formik={formik}
                message={"Please enter valid email"}
                value={formik?.values?.replyTo}
                onChange={(e) => handleOnChange(e?.target?.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                isDisabled={formik?.values?.useDefault}
                style={{
                  width: "230px",
                  height: "45px",
                }}
                styleWrapper={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "1px",
                  justifyContent: "center",
                  marginLeft: "20px",
                }}
                Wrapper={{ flexDirection: "row", alignItems: "baseline" }}
                labelStyle={{
                  color:
                    formik?.values?.useDefault
                      ? "var(--Gray-100, #9e9ead)"
                      : "black",
                  fontSize: "12px",
                  fontWeight: 400,
                }}
                error={formik.values?.error}
              />
              <InfoTooltip text="Replies to this email will go to this address, instead of the sender's default." style={{ marginLeft: '6px' }} />
            </div>
            <div className="use-default">
              <CheckBox
                checked={formik?.values?.useDefault}
                onChange={() => {
                  formik.setFieldValue(
                    "useDefault",
                    !formik?.values?.useDefault
                  );
                  formik.setFieldValue("replyTo", "");
                  formik.setFieldValue("error", false);
                }}
                text="use default"
              />
            </div>
          </div>
        {previewTemplete ? (
          <Editor
            setJsonContent={setJsonContentEdit}
            setHtmlContent={setHtmlContentEdit}
            preview={enableEdit}
            jsonContent={jsonContentEdit}
            tokenList={tokenListEdit}
            emailEditorRef={emailEditorRef}
            setSavedEmails={setSavedEmails}
            savedEmails={savedEmails}
          />
        ) : (
          <CreateLetterEditor
            setJsonContent={setJsonContent}
            setHtmlContent={setHtmlContent}
            jsonContent={jsonContent}
            tokenList={tokenList}
          />
        )}
        <div className={`buttons-wrapper  ${buttonClassName}`}>
          {withSubject && (
            <div style={{
              width: 730,
            }}
              className="buttons-wrapper-subject"
            >
              <InputFieldPrimary
                titleStyle={{
                  fontFamily: fontConfig.SendLetterInputFieldPrimaryFont.family,
                  fontWeight: '400',
                  fontSize: '12px',
                  lineHeight: '18px',
                  color: '#4F4F4F',
                }}
                mandatory={true}
                {...{
                  formik,
                  title: 'Subject',
                  name: 'subject',
                  checkValidation: true,
                }}
                value={formik.values?.subject}
                handleChange={(e) => {
                  formik.setFieldValue('subject', e.target?.value);
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                  }
                  if (e.key === ' ' && formik.values?.subject === '') {
                    e.preventDefault();
                  }
                }}
              />
            </div>
          )}
          <div className="create-letter__actions">
            {prevouis && (
              <Button
                onClick={prevouisOnClick}
                className="create-letter__actions-btn cancel"
                style={{ position: "absolute", left: "16rem" }}
                variant="primary-outline"
                size="md"
              >
                Previous
              </Button>
            )}

            <>
              {buttons.map((button) => (
                <Button
                  className={button.className}
                  key={button.id}
                  onClick={button.action}
                  disabled={button.disabled}
                  variant={button.variant}
                  size="md"
                >
                  {button.loading ? (
                    <div className="d-flex">
                      <CircularProgress
                        size={22}
                        style={{
                          color: "#ffffff",
                        }}
                      />
                    </div>
                  ) : (
                    button.label
                  )}
                </Button>
              ))}
            </>
          </div>
          {!enableEdit && previewTemplete && (
            <div className="test-email-wrapper">
              <div className="test-email">
                
                <EmailsList
                  setSavedEmails={setSavedEmails}
                  addEmailsHandler={addEmailsHandler}
                  list={savedEmails}
                  removeEmail={removeEmailHandler}
                  placeholder={savedEmails.length === 0 ? "Enter Emails" : ""}
                  className={"test-email-content"}
                  
                />
              </div>
              <Button
                className={"create-letter__actions-btn submit"}
                onClick={sendTestEmail}
                disabled={savedEmails?.length === 0}
                size="md"
                variant="primary"
                style={{
                  minWidth: "120px",
                }}
              >
                {testEmailloading ? (
                  <div className="d-flex">
                    <CircularProgress
                      size={22}
                      style={{
                        color: "#ffffff",
                      }}
                    />
                  </div>
                ) : (
                  "Send Test Email"
                )}
              </Button>
            </div>
          )}
        </div>
      </div>

      <Dialog
        open={openConfirmSaveTemplateModal}
        onClose={() => {
          // setOpenConfirmSaveTemplateModal(false);
        }}
        PaperProps={{
          style: {
            width: "600px",
            height: "fit-content",
            overflow: "hidden",
            borderRadius: "22px",
            maxWidth: "600px",
          },
        }}
        fullWidth
        maxWidth={"md"}
      >
        <ConfirmSaveTemplateModal
          closeModal={() => {
            setOpenConfirmSaveTemplateModal(false);
          }}
          formik={formik}
          field="templateName"
          createTemplate={createTemplateHandler}
          saveTemplate={() => {
            enableEdit || previewTemplete
              ? updateTemplate()
              : saveTemplateHandler();
          }}
          saveTemplateLoading={
            enableEdit || previewTemplete
              ? updateTemplateLoading
              : saveTemplateLoading
          }
          enableEdit={enableEdit}
          previewTemplete={previewTemplete}
        />
      </Dialog>
    </div>
  );
};

export default EmailEditor;
